/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Tooltip_Techsourcesteamdb4Inputs */

const id_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const ms_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const da_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const de_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const en_us2_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const es_es2_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const es_mx2_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const fil_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const fr_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const it_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const hu_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const nl_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const no_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const pl_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const pt_br2_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const pt_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const ro_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const fi_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB:tä`)
};

const sv_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const vi_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const tr_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const cs_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const bg_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const ru_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const uk_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const ar_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const hi_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const th_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const ja_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const zh_cn2_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const zh_hant1_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const ko_offerdetail_tooltip_techsourcesteamdb4 = /** @type {(inputs: Offerdetail_Tooltip_Techsourcesteamdb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

/**
* | output |
* | --- |
* | "SteamDB" |
*
* @param {Offerdetail_Tooltip_Techsourcesteamdb4Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_tooltip_techsourcesteamdb4 = /** @type {((inputs?: Offerdetail_Tooltip_Techsourcesteamdb4Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Tooltip_Techsourcesteamdb4Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "ms") return ms_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "da") return da_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "de") return de_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "en-US") return en_us2_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "fil") return fil_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "fr") return fr_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "it") return it_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "hu") return hu_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "nl") return nl_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "no") return no_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "pl") return pl_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "pt") return pt_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "ro") return ro_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "fi") return fi_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "sv") return sv_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "vi") return vi_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "tr") return tr_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "cs") return cs_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "bg") return bg_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "ru") return ru_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "uk") return uk_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "ar") return ar_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "hi") return hi_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "th") return th_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "ja") return ja_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_tooltip_techsourcesteamdb4(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_tooltip_techsourcesteamdb4(inputs)
	return ko_offerdetail_tooltip_techsourcesteamdb4(inputs)
});
export { offerdetail_tooltip_techsourcesteamdb4 as "offerDetail.tooltip.techSourceSteamDb" }